import { render, staticRenderFns } from "./RangeDetail.vue?vue&type=template&id=3924ae78&scoped=true"
import script from "./RangeDetail.vue?vue&type=script&lang=js"
export * from "./RangeDetail.vue?vue&type=script&lang=js"
import style0 from "./RangeDetail.vue?vue&type=style&index=0&id=3924ae78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3924ae78",
  null
  
)

export default component.exports